/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SolicitationCommentThread_solicitation$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SolicitationQuickView_solicitation$ref: FragmentReference;
declare export opaque type SolicitationQuickView_solicitation$fragmentType: SolicitationQuickView_solicitation$ref;
export type SolicitationQuickView_solicitation = {|
  +solicitation: ?{|
    +subject: string,
    +message: ?string,
    +$fragmentRefs: SolicitationCommentThread_solicitation$ref,
  |},
  +$refType: SolicitationQuickView_solicitation$ref,
|};
export type SolicitationQuickView_solicitation$data = SolicitationQuickView_solicitation;
export type SolicitationQuickView_solicitation$key = {
  +$data?: SolicitationQuickView_solicitation$data,
  +$fragmentRefs: SolicitationQuickView_solicitation$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "kind": "Fragment",
  "name": "SolicitationQuickView_solicitation",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "id",
      "type": "ID!",
      "defaultValue": ""
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "solicitation",
      "storageKey": null,
      "args": (v0/*: any*/),
      "concreteType": "SolicitationNode",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "subject",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "message",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SolicitationCommentThread_solicitation",
          "args": (v0/*: any*/)
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cb6b1a788990f61f1d95f8842fdb0092';
module.exports = node;
